import type CurrentRouteValues from '../_hooks/useCurrentRoute/types';
import WizStepId from '../_steps/enums/WizStepId';

const getCurrentStepFromRoute = (currentRoute: CurrentRouteValues) => {
  const { style, finish, size, accessory, isAccessory } = currentRoute;

  const steps = {
    [0]: WizStepId.Accessory,
    [1]: WizStepId.Size,
    [2]: WizStepId.Finish,
    [3]: WizStepId.Style,
  };

  const accessorySteps = {
    [0]: WizStepId.Size,
    [1]: WizStepId.Accessory,
  };

  const accessoryIdx = [size, accessory].findIndex(({ value }) => !!value);
  const idx = [accessory, size, finish, style].findIndex(
    ({ value }) => !!value,
  );

  return isAccessory
    ? accessorySteps[accessoryIdx as keyof typeof accessorySteps]
    : steps[idx as keyof typeof steps];
};

export default getCurrentStepFromRoute;
